module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.downloadReportsModel) ? _c('uiv-modal', {
    attrs: {
      "append-to-body": "",
      "footer": false,
      "title": "Download Reports",
      "backdrop": false,
      "size": "sm"
    },
    model: {
      value: (_vm.showDownloadReportsDialog),
      callback: function($$v) {
        _vm.showDownloadReportsDialog = $$v
      },
      expression: "showDownloadReportsDialog"
    }
  }, [_c('download-reports-dialog', {
    attrs: {
      "value": _vm.downloadReportsModel,
      "reportServices": _vm.reportServices
    },
    on: {
      "dialogClosed": _vm.onDownloadReportsDialogClosed
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "relative",
      "z-index": "1060"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.value.subject) + ": " + _vm._s(_vm.currentReportName) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "report-query-string-commodity-edit"
    }
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCommodity),
      expression: "selectedCommodity"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "report-query-string-commodity-edit",
      "disabled": !_vm.needsCommodity
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCommodity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshChart]
    }
  }, _vm._l((_vm.commoditySelectList), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(" " + _vm._s(item) + " ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    on: {
      "click": _vm.downloadReportClick
    }
  }, [_vm._v("Download...")])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "previous-report-button",
      "disabled": ""
    }
  }, [_vm._v("Previous")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "id": "next-report-button"
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "report-query-string-edit"
    }
  }, [_vm._v("Timepoint")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "report-query-string-edit",
      "disabled": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "report-query-string-subtime-edit"
    }
  }, [_vm._v("Subtime")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "report-query-string-subtime-edit",
      "disabled": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7 pull-right"
  }, [_c('label', {
    staticClass: "pull-right",
    attrs: {
      "for": "showAsTableCheckbox"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "showAsTableCheckbox"
    }
  }), _vm._v("\n                            Table View\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "100%",
      "max-height": "60vh",
      "height": "60vh"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "95%",
      "position": "absolute",
      "width": "95%"
    },
    attrs: {
      "id": "report-carousel-report-div"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a1fca46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a1fca46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/report-carousel/report-carousel.vue.html
// module id = 1093
// module chunks = 0